<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['dischargepatient']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-discharge size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Discharge</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :busy="IsBusy"
                show-empty
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading data...</strong></div></template>
              <template #empty><div class="text-center text-muted my-3"><strong>No data found</strong></div></template>
              <template #cell(index)="data">
                {{ ((currentPage - 1) * perPage) + data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.patient,data.item.discharge_notes,data.item.discharge_date,data.item.follow_up_date,data.item.date_of_admission,data.item.diagnosis,data.item.medical_summary,data.item.investigation_done,data.item.treatment_given,data.item.treatment_discharge,data.item.recommendation)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>

                <router-link :to="{ path: '/printdischargepatient',  query: {id: data.item.id}}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> </router-link>

                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Discharged Patients</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-discharge" centered title="New Discharge" title-class="font-18" hide-footer>
        <form @submit.prevent="addDischarge">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="visits" :custom-label="customLabel" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Admission Date</label>
            <input v-model="date_of_admission" type="date" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Medical Summary</label>
              <textarea v-model="medical_summary" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Diagnosis</label>
              <textarea v-model="diagnosis" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Investigation Done</label>
              <textarea v-model="investigation_done" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Treatment Given</label>
              <textarea v-model="treatment_given" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Treatment On Discharge</label>
              <textarea v-model="treatment_discharge" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Discharge Notes</label>
              <textarea v-model="discharge_notes" rows="2" class="form-control"></textarea>
            </div>
            <!-- <div class="form-group mb-2">
            <label>Recommendation</label>
              <textarea v-model="recommendation" rows="2" class="form-control"></textarea>
            </div> -->
            <div class="form-group mb-2">
            <label>Discharge Date</label>
            <input v-model="discharge_date" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Follow up Date</label>
            <input v-model="follow_up_date" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-discharge')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-discharge" centered title="Edit Discharge" title-class="font-14" hide-footer>
        <form @submit.prevent="editDischarge">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient</label>
              <multiselect v-model="patient" :options="visits" :custom-label="customLabel" label="name"></multiselect>

            </div>
            <div class="form-group mb-2">
            <label>Admission Date</label>
            <input v-model="date_of_admission" type="date" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Medical Summary</label>
              <textarea v-model="medical_summary" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Diagnosis</label>
              <textarea v-model="diagnosis" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Investigation Done</label>
              <textarea v-model="investigation_done" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Treatment Given</label>
              <textarea v-model="treatment_given" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Treatment On Discharge</label>
              <textarea v-model="treatment_discharge" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Discharge Notes</label>
              <textarea v-model="discharge_notes" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Discharge Date</label>
            <input v-model="discharge_date" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Follow up Date</label>
            <input v-model="follow_up_date" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-discharge')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-discharge" centered title="Delete Discharge " title-class="font-18" hide-footer>
        <form @submit.prevent="removeDischarge">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Discharge for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-discharge')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { visitMethods,dischargeMethods, visitComputed, dischargeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Discharged Patients",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Discharged Patients",
      items: [ {text: "Dashboard",to: "/",}, {text: "Discharged Patients",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          // { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'patientct', label: 'Patient Contact', visible: true },
          { key: 'discharge_notes', label: 'Discharge Notes', visible: true },
          { key: 'medical_summary', label: 'Medical Summary', visible: true },
          { key: 'diagnosis', label: 'Diagnosis', visible: true },
          { key: 'investigation_done', label: 'Investigation Done', visible: true },
          { key: 'treatment_given', label: 'Treatment Given', visible: true },
          { key: 'date_of_admission', label: 'Admission Date', visible: true },
          { key: 'discharge_date', label: 'Discharge Date', visible: true },
          { key: 'follow_up_date', label: 'Follow up Date', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      discharge_notes:'',
      date_of_admission:'',
      medical_summary:'',
      diagnosis:'',
      investigation_done:'',
      treatment_discharge:'',
      treatment_given:'',
      discharge_date:new Date().toLocaleDateString('fr-CA'),
      follow_up_date:'',
    };
  },
  computed: {
    ...dischargeComputed,
    ...visitComputed,
    List() { return this.TotalRows; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.discharges.map((d) => ({...d }))},
    IsBusy() { return this.isBusy; },
  },
  mounted() {
    this.loadDischarges();
    this.fetchVisits();
  },
  watch: {
    currentPage() {
      this.loadDischarges();
    },
    perPage() {
      this.currentPage = 1;
      this.loadDischarges();
    },
    filter() {
      this.currentPage = 1;
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.loadDischarges();
      }, 300);
    },
  },
  methods: {
    ...dischargeMethods,
    ...visitMethods,
    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    async loadDischarges() {
      this.isBusy = true;
      const response = await this.fetchDischarges({
        page: this.currentPage,
        per_page: this.perPage,
        search: this.filter || "",
      });
      this.TotalRows = response.data.pagination?.total || 0;
      this.isBusy = false;
    },
    edit(id,patient,discharge_notes,discharge_date,follow_up_date,date_of_admission,medical_summary,diagnosis,investigation_done,treatment_given,treatment_discharge){
      this.id=id;
      this.patient=patient;
      this.date_of_admission=date_of_admission;
      this.medical_summary=medical_summary;
      this.diagnosis=diagnosis;
      this.investigation_done=investigation_done;
      this.treatment_given=treatment_given;
      this.treatment_discharge=treatment_discharge;
      this.follow_up_date=follow_up_date;
      this.discharge_date=discharge_date;
      this.discharge_notes=discharge_notes;
      this.$bvModal.show('edit-discharge')
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-discharge')
    },
    async addDischarge() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("date_of_admission", this.date_of_admission);
      formData.append("medical_summary", this.medical_summary);
      formData.append("diagnosis", this.diagnosis);
      formData.append("investigation_done", this.investigation_done);
      formData.append("treatment_given", this.treatment_given);
      formData.append("treatment_discharge", this.treatment_discharge);
      formData.append("discharge_date", this.discharge_date);
      formData.append("follow_up_date", this.follow_up_date);
      formData.append("discharge_notes", this.discharge_notes);
      formData.append("reason", this.reason);
      let url = "/adddischarge";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDischarges();
        this.fetchVisits();
        this.$bvModal.hide('new-discharge');
        this.patient="";
        this.discharge_date="";
        this.discharge_notes="";
        this.follow_up_date="";
        this.date_of_admission="";
        this.medical_summary="";
        this.diagnosis="";
        this.investigation_done="";
        this.treatment_given="";
        this.treatment_discharge="";        
        this.$toast.success("New Patient Discharge Added");
      }
      });
    },
    async editDischarge(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("patient", this.patient.patient_id);
    formData.append("discharge_date", this.discharge_date);
    formData.append("discharge_notes", this.discharge_notes);
    formData.append("date_of_admission", this.date_of_admission);
    formData.append("medical_summary", this.medical_summary);
    formData.append("diagnosis", this.diagnosis);
    formData.append("investigation_done", this.investigation_done);
    formData.append("treatment_given", this.treatment_given);
    formData.append("treatment_discharge", this.treatment_discharge);
    formData.append("follow_up_date", this.follow_up_date);
    formData.append("reason", this.reason);
    let url = "/updatedischarge";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDischarges();
        this.$bvModal.hide('edit-discharge');
        this.patient="";
          this.discharge_date="";
          this.discharge_notes="";
          this.follow_up_date="";
          this.date_of_admission="";
          this.medical_summary="";
          this.diagnosis="";
          this.investigation_done="";
          this.treatment_given="";
          this.treatment_discharge="";    
          this.reason="";
          this.$toast.success("Patient Discharge Updated");
      }
    });
    },
    async removeDischarge() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removedischarge";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDischarges();
        this.$bvModal.hide('delete-discharge');
        this.$toast.error("Patient Discharge Deleted");
      }
    });
    },
  },
};
</script>
